import utils from '@/utils';
import requester, { IRequesterResponse } from '@/utils/requester';

export interface IParamsGetPhr {
  uid: string;
  filter?: { type?: string; tag?: string };
}

const phrApi = {
  async get(options: IParamsGetPhr) {
    const { type, tag } = options.filter || {};
    if (!utils.isObjectId(options.uid)) {
      window.location.href = '/';
      return null as unknown as IRequesterResponse;
    }

    const result: IRequesterResponse = await requester.get(`/phr/v1/phrs`, {
      params: {
        uid: options.uid,
        type,
        tag,
      },
    });
    return result;
  },
};

export default phrApi;
